import { refreshSession, signOut } from '@/auth/cognito.service';
import { actionType as UserActionType } from '@/services/user/action';
import Router from 'next/router';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { actionType } from './action_reducer';
import { updateUserFunderMapping } from './migration.service';

function* migUserFunderMappingSaga() {
    console.log('migUserFunderMappingSaga')
    try {
        //update Mapping
        yield call(updateUserFunderMapping);
        //Refresh current session
        yield call(refreshSession);
        //Update user principal
        yield put({ type: UserActionType.GET_USER_PRINCIPAL });
        Router.push('/');
    }
    catch (error) {
        console.log(error);
        yield call(signOut, () => Router.push('/user/login'))
    }
}

function* rootSaga() {
    yield all([takeEvery(actionType.UPDATE_USER_PRINCIPAL_MAPPING, migUserFunderMappingSaga),])
}

export default rootSaga;

